<template>
  
  <div class="sixteen wide field">
    <label class="form-label">
      {{ organ.description }} <span class="red text">*</span>
      <div :id="_uid + '_organ_change_dropdown'" v-show="organ.changes.length > 0" class="ui dropdown">
        <a class="m-l-10 clickable">
          <i class="arrow alternate circle down outline blue icon"></i>
        </a>
        <div class="menu" style="width: 400px;">
          <div class="ui icon search input" style="width: 390px !important;">
            <i class="search icon"></i>
            <input type="text" placeholder="Pesquisar...">
          </div>
          <div class="scrolling menu">
            <div v-for="change in changes" class="item" @click="$refs.textEditor.addContents(change.descriptionContents)">
              {{ change.name }}
            </div>
          </div>
        </div>
      </div>      
    </label>
    <text-editor ref="textEditor" />
  </div>

</template>

<script>

  import _ from "underscore"
  import TextEditor from "@/components/text-editor.vue"

  export default {
    
    name: "OrganTextEditor",

    data() {
      return {
        changes: [],
      }
    },

    props: ["organ"],

    components: {
      TextEditor,
    },

    mounted() {

      this.changes = _.sortBy(this.organ.changes, "name")

      $(`#${this._uid}_organ_change_dropdown`).dropdown()

      this.$refs.textEditor.setContents(this.organ.defaultTextContents)
    },

    methods: {

      getText() {
        return this.$refs.textEditor.getText()
      },

      getContents(options) {
        return this.$refs.textEditor.getContents(options)
      },

      isEmpty() {
        return this.$refs.textEditor.isEmpty()
      },

      clear() {
        this.$refs.textEditor.clear()
      },
    },
  }

</script>